import styled from 'styled-components';

export const VisitServiceColumn = styled.div`
  padding: 5rem 0;

  &:nth-child(odd) {
    .flip_txtimg {
      display: flex;
    }
  }

  &:nth-child(even) {
    background: #f7f7f7;
    .flip_txtimg {
      display: flex;
      flex-direction: row-reverse;
    }
  }

  &.new_developmentcontent {
    background: #f7f7f7;

    @media (max-width: 991.98px) {
      padding: 0 0 3rem;
    }
  }
`;
